import { css } from '@emotion/core';
import { media } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';

/* eslint-disable import/prefer-default-export */

export var researchDriver = {
  name: "19pk894",
  styles: "display:flex;flex-direction:column;align-items:flex-start;margin:0 auto;margin-top:80px;max-width:1020px;flex:0 0;"
};
export var container = {
  name: "b77kjb",
  styles: "overflow:auto hidden;width:100%;max-width:100%;"
};
export var cards = {
  name: "1mtqkr9",
  styles: "display:flex;gap:16px;margin:16px 0;overflow-x:auto;"
};
export var heading = /*#__PURE__*/css(designTokenFonts.heading, " margin-left:14px;", media('>=tablet') && {
  name: "qbubgm",
  styles: "margin-left:0;"
});